module.exports = __webpack_public_path__ + "img/shop-abercrombie.eeaf5cca.png";